import React, { useEffect, useState } from "react";
import * as APIModels from "../../models";
import AttorneySelect from "../../components/shared/AttorneySelect";
import Select, { ActionMeta } from "react-select";
import { DataService } from "../../services/DataService";
import { ReportService } from "../../services/SubmissionService";
import MaterialTable from "@material-table/core";
import Footer from "../../components/shared/Footer";
import { ExportCsv } from "@material-table/exporters";

type NameValueOptionType = { label: string; value: string };

export default function SubmissionSearch(): JSX.Element {
    const [searching, setSearching] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [reportRequest, setReportRequest] = useState(
        {} as APIModels.SubmissionReportingRequest
    );

    const [attorneyId, setAttorneyId] = useState("");
    const [countyId, setCountyId] = useState("");
    const [stateId, setStateId] = useState("");
    const [stateObj, setStateObj] = useState({} as NameValueOptionType);
    const [countyObj, setCountyObj] = useState({} as NameValueOptionType);

    const [searchByCountyOptions, setSearchByCountyOptions] = useState(
        [] as NameValueOptionType[]
    );
    const [stateOptions, setStateOptions] = useState(
        [] as NameValueOptionType[]
    );

    const [firmId, setFirmId] = useState("");

    const [data, setData] = useState([] as APIModels.SubmissionSearchResults[]);

    const [searchById, setSearchById] = useState("0");

    const onSearchClick = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSearching(true);
        ReportService.search({
            attorneyId: attorneyId,
            body: reportRequest,
        })
            .then((response) => {
                if (response.successful) {
                    setData(response.data!);
                } else {
                    setErrorMessage(response.errorMessage!);
                }
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage(error.message);
            })
            .finally(() => {
                setSearching(false);
            });
    };

    const onFirmSelected = (id: string, name: string) => {
        setFirmId(id);
    };

    const onAttorneySelected = (id: string, name: string) => {
        setAttorneyId(id);
    };

    const onStateChange = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setStateId(value!.label);
        setStateObj(value!);
    };

    const onSelectCounty = (
        value: NameValueOptionType | null,
        actionMeta: ActionMeta<NameValueOptionType>
    ) => {
        setCountyId(value!.value);
        setReportRequest({
            ...reportRequest,
            countyID: value!.value!,
        });
        setCountyObj(value!);
    };

    useEffect(() => {
        DataService.getStates().then((response) => {
            const options: NameValueOptionType[] = [];
            response.forEach((state) => {
                options.push({
                    label: state.abbreviation!,
                    value: state.id!,
                });
            });
            setStateOptions(options);
        });
    }, []);

    useEffect(() => {
        DataService.getCountiesByPortal({
            state: "FL",
            all: true,
        })
            .then((response) => {
                // set the response to the county options
                const options: NameValueOptionType[] = [];
                response.forEach((county) => {
                    options.push({
                        label: county.name!,
                        value: county.id!,
                    });
                });
                setSearchByCountyOptions(options);
            })
            .catch((error) => {
                console.log(error);
            });
    }, [stateId]);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Reporting</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            Reporting
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Submissions
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <form action="#" onSubmit={onSearchClick}>
                    <div className="mb-3">
                        <AttorneySelect
                            onAttorneySelected={onAttorneySelected}
                            onFirmSelected={onFirmSelected}
                        />
                    </div>
                    <div className="row mb-3">
                        <div className="col-6 ">
                            <label htmlFor="txtFrom" className="form-label">
                                From:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="txtFrom"
                                    required
                                    placeholder="mm/dd/yyyy"
                                    aria-describedby="inputGroupPrepend"
                                    value={reportRequest.startDate!}
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            startDate:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtTo" className="form-label">
                                To:
                            </label>
                            <div className="input-group">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="txtTo"
                                    required={true}
                                    placeholder="mm/dd/yyyy"
                                    aria-describedby="inputGroupPrepend"
                                    value={reportRequest.endDate!}
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            endDate: event.currentTarget.value!,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-6">
                            <label
                                htmlFor="selectSeachBy"
                                className="form-label"
                            >
                                State:
                            </label>
                            <Select
                                options={stateOptions}
                                onChange={onStateChange}
                                styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                    }),
                                }}
                                value={stateObj}
                            />
                        </div>
                        <div className="col-6">
                            <label
                                htmlFor="selectSeachBy"
                                className="form-label"
                            >
                                County:
                            </label>
                            <Select
                                options={searchByCountyOptions}
                                onChange={onSelectCounty}
                                styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                    }),
                                }}
                                value={countyObj}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label htmlFor="txtContains" className="form-label">
                                UCN:
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtContains"
                                    aria-describedby="inputGroupPrepend"
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            ucn: event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label htmlFor="txtContains" className="form-label">
                                Case Number:
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtContains"
                                    aria-describedby="inputGroupPrepend"
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            caseNumber:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <label htmlFor="txtContains" className="form-label">
                                Refrence Number:
                            </label>
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="txtContains"
                                    aria-describedby="inputGroupPrepend"
                                    onChange={(event) =>
                                        setReportRequest({
                                            ...reportRequest,
                                            refrenceNumber:
                                                event.currentTarget.value,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="text-end mb-3">
                            {searching ? (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="button"
                                    disabled={true}
                                >
                                    <span
                                        className="spinner-border spinner-border-sm me-1"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Searching...
                                </button>
                            ) : (
                                <button
                                    className="btn btn-primary waves-effect waves-light mt-2"
                                    type="submit"
                                >
                                    Search
                                </button>
                            )}
                            <div style={{ color: "red" }}>{errorMessage}</div>
                        </div>
                    </div>
                </form>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <MaterialTable
                                columns={[
                                    {
                                        title: "NO",
                                        field: "submissionID",
                                        render: (rowData) => (
                                            <a
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#526dee",
                                                }}
                                                href={`/reporting/submission/${rowData.submissionID}`}
                                            >
                                                {rowData.submissionID}
                                            </a>
                                        ),
                                    },
                                    {
                                        title: "CRT_CASE_NO",
                                        field: "caseNumber",
                                    },
                                    {
                                        title: "UCN",
                                        field: "ucn",
                                        headerStyle: {
                                            whiteSpace: "nowrap",
                                            textAlign: "center",
                                        },
                                        cellStyle: {
                                            whiteSpace: "nowrap",
                                            textAlign: "center",
                                        },
                                    },
                                    {
                                        title: "REFERENCE NUMBER",
                                        field: "referenceNumber",
                                        cellStyle: {
                                            whiteSpace: "nowrap",
                                            textAlign: "center",
                                        },
                                    },
                                    { title: "COUNTY", field: "countyName" },
                                    {
                                        title: "DIVISION",
                                        field: "divisionName",
                                    },
                                    {
                                        title: "STATUS",
                                        field: "submissionStatus",
                                    },
                                ]}
                                data={data}
                                title="e-Filing Report"
                                options={{
                                    exportAllData: true,
                                    exportMenu: [
                                        {
                                            label: "Submission Search",
                                            exportFunc: (cols, datas) =>
                                                ExportCsv(
                                                    cols,
                                                    datas,
                                                    `EFileReport`
                                                ),
                                        },
                                    ],
                                    tableLayout: "auto",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
